// @flow
import { trackRegisterActionWithAuxData } from 'app/common/lib/util/trackRegisterAction';

export const trackMagicLink = (action: string, email: string, password: string) => {
  trackRegisterActionWithAuxData(`unauth.magic_link_login.${action}`, {
    has_email_data: !!email,
    has_password_data: !!password,
  });
};

export default undefined;
